import React from "react";
import styles from "../styles/CustomTabs.module.scss";

const CustomTabs = ({ tabs, activeKey, onSelect }) => {
  return (
    <div className={styles.primaryTabs}>
      <div className={styles.nav}>
        {tabs.map((tab) => (
          <div key={tab.key} className={styles.navItem}>
            <button
              className={`${styles.navLink} ${
                activeKey === tab.key ? styles.active : ""
              }`}
              onClick={() => onSelect(tab.key)}
            >
              <span className="d-flex align-items-center gap-2">
                {tab.icon}
                {tab.label}
              </span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomTabs;
